module.exports = __webpack_public_path__ + "static/media/nasolabial_right.3658b047.svg";